import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6 flex items-center justify-center",
  style: {"height":"500px"}
}
const _hoisted_2 = {
  key: 1,
  class: "mt-6 flex items-center justify-center",
  style: {"height":"500px"}
}
const _hoisted_3 = { class: "text-red-500 flex flex-col items-center" }
const _hoisted_4 = {
  key: 2,
  class: "relative"
}
const _hoisted_5 = { class: "mb-4 p-3 bg-yellow-100 border border-yellow-300 rounded-md text-yellow-700 flex items-center" }
const _hoisted_6 = { class: "grid grid-cols-3 gap-6" }
const _hoisted_7 = { class: "col-span-2 border border-gray-200 rounded-lg p-4" }
const _hoisted_8 = { class: "mt-4 flex items-center p-1" }
const _hoisted_9 = { class: "flex space-x-2" }
const _hoisted_10 = { class: "h-[60vh]" }
const _hoisted_11 = {
  key: 0,
  class: "mt-4 p-3 bg-green-100 border border-green-300 rounded-md text-green-700 flex items-center"
}
const _hoisted_12 = {
  key: 1,
  class: "mt-4 p-3 bg-red-100 border border-red-300 rounded-md text-red-700 flex items-center"
}
const _hoisted_13 = {
  key: 3,
  class: "mt-6 flex items-center justify-center absolute inset-0 bg-white bg-opacity-75 z-10"
}
const _hoisted_14 = {
  key: 4,
  class: "relative"
}
const _hoisted_15 = { class: "grid grid-cols-3 gap-6" }
const _hoisted_16 = { class: "col-span-2 border border-gray-200 rounded-lg p-4" }
const _hoisted_17 = { class: "mt-4 flex justify-between items-center p-1" }
const _hoisted_18 = { class: "flex space-x-2" }
const _hoisted_19 = { class: "col-span-1" }
const _hoisted_20 = { class: "bg-white border border-gray-200 rounded-lg shadow-sm p-4" }
const _hoisted_21 = { class: "overflow-auto h-[60vh]" }
const _hoisted_22 = { class: "w-full text-sm text-left text-gray-500 dark:text-gray-400" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "py-4 px-6 hover:translate-x-1 transition-transform duration-150" }
const _hoisted_25 = { class: "py-4 px-6" }
const _hoisted_26 = { class: "py-4 px-6" }
const _hoisted_27 = { class: "py-4 px-6" }
const _hoisted_28 = {
  key: 0,
  class: "mt-4 p-3 bg-green-100 border border-green-300 rounded-md text-green-700 flex items-center"
}
const _hoisted_29 = {
  key: 1,
  class: "mt-4 p-3 bg-red-100 border border-red-300 rounded-md text-red-700 flex items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExcelViewer = _resolveComponent("ExcelViewer")!

  return (_ctx.isFile1Loading || _ctx.isFile2Loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[7] || (_cache[7] = [
        _createElementVNode("div", { class: "text-gray-500 flex flex-col items-center" }, [
          _createElementVNode("svg", {
            class: "animate-spin h-10 w-10 text-primary mb-4",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }),
            _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
          ]),
          _createElementVNode("p", null, "Loading spreadsheet data...")
        ], -1)
      ])))
    : (_ctx.file1Error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("svg", {
              class: "h-10 w-10 text-red-500 mb-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              })
            ], -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.file1Error), 1),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retryFile1Load && _ctx.retryFile1Load(...args))),
              class: "mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, " Retry Loading ")
          ])
        ]))
      : (_ctx.file2Error && !_ctx.file1Error && !_ctx.isFile1Loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[9] || (_cache[9] = _createElementVNode("svg", {
                class: "h-5 w-5 mr-2",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.file2Error), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "text-base font-medium text-gray-700 mb-3" }, "Spreadsheet", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args))),
                      class: "inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                    }, _cache[10] || (_cache[10] = [
                      _createElementVNode("svg", {
                        class: "h-4 w-4 mr-1.5",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        })
                      ], -1),
                      _createTextVNode(" Export Excel ")
                    ])),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.exportToCsv && _ctx.exportToCsv(...args))),
                      class: "inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                    }, _cache[11] || (_cache[11] = [
                      _createElementVNode("svg", {
                        class: "h-4 w-4 mr-1.5",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        })
                      ], -1),
                      _createTextVNode(" Export CSV ")
                    ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ExcelViewer, {
                    ref: "excelViewerComponent1",
                    fileData: _ctx.excelFile1Data || undefined,
                    readOnly: true,
                    cellCoordinates: _ctx.cellDataArray.map(item => item.cellCoordinate),
                    select: _ctx.selectedCoordinates,
                    onCellValues: _ctx.handleCellValues1
                  }, null, 8, ["fileData", "cellCoordinates", "select", "onCellValues"])
                ])
              ]),
              _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"col-span-1\" data-v-424d83a6><div class=\"bg-white border border-gray-200 rounded-lg shadow-sm p-4\" data-v-424d83a6><h4 class=\"text-base font-medium text-gray-700 mb-3\" data-v-424d83a6>Comparison Results</h4><div class=\"flex items-center justify-center h-[60vh]\" data-v-424d83a6><div class=\"text-gray-500 text-center\" data-v-424d83a6><svg class=\"h-12 w-12 mx-auto mb-4 text-gray-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" data-v-424d83a6><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\" data-v-424d83a6></path></svg><p class=\"text-lg font-medium mb-2\" data-v-424d83a6>No Comparison Available</p><p class=\"text-sm\" data-v-424d83a6>No AI-generated template was found for comparison. You can still view and edit the uploaded template.</p></div></div></div></div>", 1))
            ]),
            (_ctx.saveSuccess)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[14] || (_cache[14] = _createElementVNode("svg", {
                    class: "h-5 w-5 mr-2",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M5 13l4 4L19 7"
                    })
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.saveSuccess), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.saveError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[15] || (_cache[15] = _createElementVNode("svg", {
                    class: "h-5 w-5 mr-2",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    })
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.saveError), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.isSaving)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[16] || (_cache[16] = [
              _createElementVNode("div", { class: "text-gray-800 flex flex-col items-center" }, [
                _createElementVNode("svg", {
                  class: "animate-spin h-10 w-10 text-primary mb-4",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })
                ]),
                _createElementVNode("p", null, "Saving changes...")
              ], -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "text-base font-medium text-gray-700 mb-3" }, "Spreadsheet", -1)),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args))),
                        class: "inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                      }, _cache[17] || (_cache[17] = [
                        _createElementVNode("svg", {
                          class: "h-4 w-4 mr-1.5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                          })
                        ], -1),
                        _createTextVNode(" Export Excel ")
                      ])),
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportToCsv && _ctx.exportToCsv(...args))),
                        class: "inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                      }, _cache[18] || (_cache[18] = [
                        _createElementVNode("svg", {
                          class: "h-4 w-4 mr-1.5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          })
                        ], -1),
                        _createTextVNode(" Export CSV ")
                      ])),
                      (_ctx.currentLayout === 'full')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleActiveViewer && _ctx.toggleActiveViewer(...args))),
                            class: "inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                          }, [
                            _cache[19] || (_cache[19] = _createElementVNode("svg", {
                              class: "h-4 w-4 mr-1.5",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                              })
                            ], -1)),
                            _createTextVNode(" Switch to " + _toDisplayString(_ctx.activeViewer === 1 ? 'AI Generated' : 'Actual'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleLayout && _ctx.toggleLayout(...args))),
                        class: "inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                      }, [
                        _cache[20] || (_cache[20] = _createElementVNode("svg", {
                          class: "h-4 w-4 mr-1.5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M4 6h16M4 12h16m-7 6h7"
                          })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.currentLayout === 'side-by-side' ? 'Change Layout to Full View' : 'Change Layout to Side by Side'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["h-[60vh]", [
          'flex gap-4',
          _ctx.currentLayout === 'side-by-side' ? 'grid grid-cols-2' : ''
        ]])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
            _ctx.currentLayout === 'side-by-side' ? 'flex-1' : 'w-full',
            _ctx.currentLayout === 'full' && _ctx.activeViewer !== 1 ? 'hidden' : ''
          ])
                    }, [
                      _createVNode(_component_ExcelViewer, {
                        ref: "excelViewerComponent1",
                        fileData: _ctx.excelFile1Data || undefined,
                        readOnly: true,
                        cellCoordinates: _ctx.cellDataArray.map(item => item.cellCoordinate),
                        select: _ctx.selectedCoordinates,
                        onCellValues: _ctx.handleCellValues1
                      }, null, 8, ["fileData", "cellCoordinates", "select", "onCellValues"])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass([
            _ctx.currentLayout === 'side-by-side' ? 'flex-1' : 'w-full',
            _ctx.currentLayout === 'full' && _ctx.activeViewer !== 2 ? 'hidden' : ''
          ])
                    }, [
                      _createVNode(_component_ExcelViewer, {
                        ref: "excelViewerComponent2",
                        fileData: _ctx.excelFile2Data || undefined,
                        readOnly: true,
                        cellCoordinates: _ctx.cellDataArray.map(item => item.cellCoordinate),
                        select: _ctx.selectedCoordinates,
                        onCellValues: _ctx.handleCellValues2
                      }, null, 8, ["fileData", "cellCoordinates", "select", "onCellValues"])
                    ], 2)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "text-base font-medium text-gray-700 mb-3" }, "Comparison Results", -1)),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("table", _hoisted_22, [
                        _cache[22] || (_cache[22] = _createElementVNode("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "py-3 px-6" }, "Field Name"),
                            _createElementVNode("th", { class: "py-3 px-6" }, "Cell Coordinate"),
                            _createElementVNode("th", { class: "py-3 px-6" }, "Relative Deviation ↓"),
                            _createElementVNode("th", { class: "py-3 px-6" }, "Manual"),
                            _createElementVNode("th", { class: "py-3 px-6" }, "AI Forecast")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combinedValues, (item) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: item.fieldName,
                              class: _normalizeClass(["bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-100 hover:shadow-md hover:translate-y-[-1px] cursor-pointer transition-all duration-150", { 'bg-blue-200 shadow-md translate-y-[-1px]': _ctx.selectedRow === item.cellCoordinate }]),
                              onClick: ($event: any) => (_ctx.handleRowClick(item.cellCoordinate))
                            }, [
                              _createElementVNode("td", _hoisted_24, _toDisplayString(item.fieldName), 1),
                              _createElementVNode("td", _hoisted_25, _toDisplayString(item.cellCoordinate), 1),
                              _createElementVNode("td", {
                                class: _normalizeClass(["py-4 px-6", {
                    'text-green-500': item.deviationStatus === 'OK',
                    'text-orange-500': item.deviationStatus === 'WARN',
                    'text-red-500': item.deviationStatus === 'ERROR'
                  }])
                              }, _toDisplayString(item.relativeDeviation), 3),
                              _createElementVNode("td", _hoisted_26, _toDisplayString(item.manualValue), 1),
                              _createElementVNode("td", _hoisted_27, _toDisplayString(item.aiForecastValue), 1)
                            ], 10, _hoisted_23))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.saveSuccess)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _cache[24] || (_cache[24] = _createElementVNode("svg", {
                      class: "h-5 w-5 mr-2",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M5 13l4 4L19 7"
                      })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.saveSuccess), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.saveError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _cache[25] || (_cache[25] = _createElementVNode("svg", {
                      class: "h-5 w-5 mr-2",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      })
                    ], -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.saveError), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
}